import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaBoxes,
  FaIndustry,
  FaUsers,
  FaTruck,
  FaTruckLoading,
  FaCogs,
  FaGlobe,
  FaHandshake,
  FaEllipsisH,
} from "react-icons/fa";

const iconMap = {
  Manufacturer: <FaIndustry />,
  Wholesaler: <FaUsers />,
  Distributor: <FaTruck />,
  Supplier: <FaTruckLoading />,
  "Industrial Services": <FaCogs />,
  Exporters: <FaGlobe />,
  Traders: <FaHandshake />,
  Other: <FaEllipsisH />,
};

// static category data
const categoryData = [
  { _id: "1", name: "Manufacturer" },
  { _id: "2", name: "Wholesaler" },
  { _id: "3", name: "Distributor" },
  { _id: "4", name: "Supplier" },
  { _id: "5", name: "Industrial Services" },
  { _id: "6", name: "Exporters" },
  { _id: "7", name: "Traders" },
  { _id: "8", name: "Other" },
];

const MainCategoryCard = () => {
  const navigate = useNavigate();

  const handleClick = (category) => {
    const formattedName = category.name.toLowerCase().replace(/\s+/g, "_");
    navigate(`/services?companyType=${formattedName}`);
  };

  return (
    <div className="flex flex-wrap gap-2 max-w-full mx-auto justify-center">
      {categoryData.map((item, index) => (
        <div
          key={item._id || index}
          onClick={() => handleClick(item)}
          className="
            w-14 h-14 sm:w-24 sm:h-24 md:w-28 md:h-28
            flex flex-col items-center justify-center
            rounded-md md:rounded-lg border border-white bg-transparent
            transition hover:cursor-pointer hover:scale-105 
          "
        >
          <div className="text-white text-sm sm:text-2xl md:text-3xl">
            {iconMap[item.name] || <FaBoxes />}
          </div>
          <span className="mt-1 sm:mt-2 text-[8px] sm:text-sm md:text-md font-medium bg-gradient-to-r from-white to-neutral-400 bg-clip-text text-transparent text-center">
            {item.name}
          </span>
        </div>
      ))}
    </div>
  );
};

export default MainCategoryCard;
